module.exports = __webpack_public_path__ + "static/media/Bevan van Rooyen.ea02bd55.jpg";